import React, { useContext, useEffect, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { AuthContext } from "../contexts/AuthContext.js";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

import "../styles/ShippingAddressPage.css";

const ShippingSchema = Yup.object().shape({
  phone_number: Yup.string().required("Téléphone requis"),
  first_name: Yup.string().required("Prénom requis"),
  last_name: Yup.string().required("Nom requis"),

  // street_number: Yup.string().required("Numéro de rue requis"),
  street: Yup.string().required("Rue requise"),
  complement: Yup.string(),
  city: Yup.string().required("Ville requise"),
  // country: Yup.string().required("Pays requis"),
  postal_code: Yup.string()
    .matches(/^[0-9]{5}$/, "Code postal invalide")
    .required("Code postal requis"),
});

const ShippingAddressPage = () => {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();

  // État local pour l'adresse de livraison
  const [selectedAddress, setSelectedAddress] = useState({
    phone_number: "",
    first_name: "",
    last_name: "",
    // street_number: "",
    street: "",
    complement: "",
    city: "",
    // country: "",
    postal_code: "",
  });

  // Récupère l'adresse de livraison depuis l'utilisateur connecté ou le localStorage
  useEffect(() => {
    if (authCtx.connected && authCtx.currentUser?.shippingAddress) {
      setSelectedAddress(authCtx.currentUser.shippingAddress);
    } else {
      const storedAddress = localStorage.getItem("shippingAddress");
      if (storedAddress) {
        try {
          const parsedAddress = JSON.parse(storedAddress);
          setSelectedAddress(parsedAddress);
        } catch (error) {
          console.error("Erreur de parsing de l'adresse stockée :", error);
        }
      }
    }
  }, [authCtx.connected, authCtx.currentUser]);

  return (
    <div className="shipping-container" style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem" }}>
      <h1 className="shipping-title">Informations de livraison</h1>
      <p>Veuillez renseigner vos informations de livraison.</p>

      <Formik
        enableReinitialize
        initialValues={selectedAddress}
        validationSchema={ShippingSchema}
        onSubmit={async (values, { setSubmitting }) => {
          // console.log("Shipping details submitted", values);

          // Si l'utilisateur est connecté, on met à jour son adresse côté serveur
          if (authCtx.connected) {
            authCtx.currentUser.shippingAddress = values;
            await authCtx.updateUser(
              authCtx.token,
              authCtx.idUser,
              authCtx.currentUser
            );
          }

          // On stocke l'adresse dans le localStorage pour les utilisateurs non connectés
          localStorage.setItem("shippingAddress", JSON.stringify(values));

          navigate("/checkout/shipping");
          setSubmitting(false);
        }}
      >
        {({ setFieldValue, values, isSubmitting }) => (
          <Form className="shipping-form">

            {/* <div className="form-group">
              <Field
                type="text"
                name="street_number"
                placeholder="Numéro*"
                className="input-field"
                autoComplete="off"
              />
              <ErrorMessage
                name="street_number"
                component="div"
                className="error"
              />
            </div> */}

            <div className="form-group">
              <Field
                type="text"
                name="street"
                placeholder="Adresse*"
                className="input-field"
                autoComplete="off"
              />
              <ErrorMessage name="street" component="div" className="error" />
            </div>

            <div className="form-group">
              <Field
                type="text"
                name="complement"
                placeholder="Complément d'adresse"
                className="input-field"
                autoComplete="off"
              />
              <ErrorMessage name="complement" component="div" className="error" />
            </div>

            <div className="form-group">
              <Field
                type="text"
                name="city"
                placeholder="Ville*"
                className="input-field"
                autoComplete="off"
              />
              <ErrorMessage name="city" component="div" className="error" />
            </div>

            {/* <div className="form-group">
              <Field
                type="text"
                name="country"
                placeholder="Pays"
                className="input-field"
                autoComplete="off"
              />
              <ErrorMessage name="country" component="div" className="error" />
            </div> */}

            <div className="form-group">
              <Field
                type="text"
                name="postal_code"
                placeholder="Code Postal*"
                className="input-field"
                autoComplete="off"
              />
              <ErrorMessage
                name="postal_code"
                component="div"
                className="error"
              />
            </div>

            {/* <div className="divider"></div> */}

            <div className="divider"></div>

            <div className="form-group">
              <Field
                type="text"
                name="first_name"
                placeholder="Prénom*"
                className="input-field"
                autoComplete="off"
              />
              <ErrorMessage
                name="first_name"
                component="div"
                className="error"
              />
            </div>

            <div className="form-group">
              <Field
                type="text"
                name="last_name"
                placeholder="Nom*"
                className="input-field"
                autoComplete="off"
              />
              <ErrorMessage name="last_name" component="div" className="error" />
            </div>

            <small style={{ color: "#333", fontSize: 12 }}>
              Votre numéro de téléphone est uniquement utilisé pour le suivi de votre livraison.
            </small>
            <div className="form-group">
              <Field
                type="text"
                name="phone_number"
                placeholder="Téléphone*"
                className="input-field"
                autoComplete="off"
              />
              <ErrorMessage
                name="phone_number"
                component="div"
                className="error"
              />
            </div>
            <br />
            <p>Les champs marqués d'un astérisque (*) sont obligatoires.</p>
            <button type="submit" className="submit-button" disabled={isSubmitting}>
              {isSubmitting ? "Chargement..." : "Valider mon adresse"}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ShippingAddressPage;
